exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leave-request[data-v-d2e1aaa0] {\n  padding: 100px 0;\n  background-color: #f7f7f7;\n}\n.leave-request .leave-request__desc[data-v-d2e1aaa0] {\n  margin: 32px 0 54px;\n  max-width: 600px;\n  line-height: 1.5;\n  letter-spacing: 0.2px;\n}\n.leave-request .leave-request__info[data-v-d2e1aaa0] {\n  opacity: 0.7;\n}", ""]);

// exports
